<template>
  <div class="fling-type">
    <navbar left-text show-home :title="title" />
    <div class="fling-type-wrapper">
      <div class="hot-column" v-show="hotRechargeList.length">
        <div class="title">热门充值</div>
        <div class="column-list">
          <hot-column-list :sku-list="hotRechargeList"></hot-column-list>
        </div>
      </div>
      <div class="all-kinds" v-show="rechargeList.length">
        <div class="title">全部充值</div>
        <div class="kind-options">
          <list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div class="sku-option" v-for="(spu, index) in rechargeList" :key="index">
              <a href="javascript:;" class="sku-details" @click="dealWith(spu.item_id, spu.sku_id, spu.platform, spu.item_type)">
                <div class="sku-intro">
                  <div class="sku-img">
                  <img v-lazy="spu.pic_url" alt="">
                </div>
                <div class="sku-name">{{spu.name}}</div>
                </div>
                <button class="recharge">立即充值</button>
              </a>
            </div>
          </list>
        </div>
      </div>
    </div>
    <div class="no-data" v-show="noData">
      <img src="../assets/img/fling-nodata.png" alt="">
      <p>暂无商品</p>
    </div>
  </div>
</template>

<script>
import { List } from 'vant'
import Navbar from '../components/NavBar'
import HotColumnList from '../components/flingCenter/HotColumn'
import api from '../utils/api'
export default {
  name: 'flingType',
  components: {
    List,
    Navbar,
    HotColumnList
  },
  data () {
    return {
      loading: false,
      finished: false,
      noData: false,
      column: '',
      pageNum: 1,
      hotRechargeList: [],
      rechargeList: [],
      skuList: []
    }
  },
  computed: {
    title () {
      return this.$route.query.title
    }
  },
  created () {
    this.$toast.loading({
      duration: 300000,
      message: '正在加载...',
      forbidClick: true
    })
    this.column = this.$route.query.column
    this.getHotRechargeList(this.column, 3)
    this.getRechargeList(this.column, this.pageNum)
  },
  activated () {
    const { column } = this.$route.query
    if (this.column !== column) {
      this.pageNum = 1
      this.finished = false
      this.noData = false
      this.hotRechargeList = []
      this.rechargeList = []
      this.column = column
      this.$toast.loading({
        duration: 300000,
        message: '正在加载...',
        forbidClick: true
      })
      this.getHotRechargeList(column, 3)
      this.getRechargeList(column, this.pageNum)
    }
  },
  methods: {
    /**
     * 分页加载
    */
    onLoad () {
      setTimeout(() => {
        this.getRechargeList(this.column, ++this.pageNum)
          .then(() => {
            this.loading = false
          })
      }, 500)
    },
    /**
     * 去办理跳转
    */
    dealWith (goodsid, skuid, platform, type) {
      if (type === 3) {
        this.$router.push({ name: 'flingOrder', query: { goodsid, skuid, platform } })
      } else {
        this.$router.push({ name: 'productDetails', query: { goodsid, skuid, platform } })
      }
    },

    /**
     * 随机获取热门充值
    */
    async getHotRechargeList (id, num) {
      const data = await api.getRandomProductList({ id, num })
      if (data) {
        this.hotRechargeList = data
      }
    },

    /**
     * 直冲商品列表
    */
    async getRechargeList (id, pageNum) {
      const res = await api.getProductList({ id, pageNum })
      if (res) {
        this.$toast.clear()
        const { code, msg, data } = res.data
        if (code === 0) {
          if (pageNum === 1) {
            this.rechargeList = data
          } else {
            this.rechargeList = [...this.rechargeList, ...data]
          }
        } else if (code === 9006) {
          if (pageNum === 1) {
            this.noData = true
          }
          this.finished = true
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.fling-type {
}
.fling-type-wrapper {
  .hot-column {
    .title {
      height: 0.85rem;
      font-size: @fz24;
      color: @base;
      padding-left: 0.3rem;
      display: flex;
      align-items: center;
    }
    .column-list {
      padding: 0.24rem 0.3rem 0.36rem;
      background-color: #fff;
    }
  }
  .all-kinds {
    .title {
      height: 0.87rem;
      padding-left: 0.3rem;
      font-size: @fz24;
      color: @base;
      display: flex;
      align-items: center;
    }
    .kind-options {
      padding: 0 0.2rem;
      background-color: #fff;
      .sku-option {
        .sku-details {
          height: 1.03rem;
          border-bottom: 0.5px solid #DFDFDF;
          .flex-between;
          .sku-intro {
            display: flex;
            align-items: center;
            padding-left: 0.13rem;
            .sku-img {
              width: 1.1rem;
              height: 0.53rem;
            }
            .sku-name {
              width: 4.2rem;
              .ellipsis2;
              font-size: @fz24;
              color: @base;
              font-weight: 700;
              padding-left: 0.22rem;
            }
          }
          .recharge {
            padding-right: 0.27rem;
            color: #4A90E2;
            font-size: @fz24;
          }
        }
      }
    }
  }
}
.no-data {
  width: 100%;
  text-align: center;
  padding-top: 1.5rem;
  img {
    width: 4.49rem;
    height: 2.9rem;
  }
  p {
    font-size: @fz32;
    color: @base;
  }
}
</style>
